module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro.1fa9627b.m4a";